import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import SidePanelItem from './SidePanelItem'
import Books from './books.png'
import MapIcon from './mapicon.png'
import Folder from './folder.png'
import Collection from './Collection'

const drawerWidth = 240

const useStyles = makeStyles({
  fullList: {
    width: 'auto',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    color: '#666',
    width: drawerWidth,
    marginTop: 100,
    height: 'calc(100vh - 170px)', // 170 because of footer,
    zIndex: 900 // light box has a zIndex of 1200 so this value should be anything less than that
  },
})

export default function SidePanelDrawer(props) {

  const { open, toggle, isMobile, collections, clickCollection, subCollectionClick, clickNavItem } = props

  const classes = useStyles()

  const handleClick = text => {
      clickNavItem(text)
  }


  

  return (
      <Drawer 
        onClose={toggle(false)}  
        className={classes.drawer}
        anchor="left"
        variant="persistent"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}>
        <div
          style={{padding: '0 20px'}}
          role="presentation"
          onClick={toggle(isMobile ? false : true)}>
        <List>
          <SidePanelItem click={handleClick} text={'Story Feed'} Icon={Books} iconHeight={22} />
          <SidePanelItem click={handleClick} text={'Story Map'} Icon={MapIcon} iconHeight={18} />
          <SidePanelItem click={handleClick} text={'Collections'} Icon={Folder}  iconHeight={22} />
        </List>
        <Divider />
        <List>
        {collections.map((collection, index) => (
            <li key={index} style={{margin: '10px 0'}}>
                <Collection 
                  collection={collection} 
                  clickCollection={clickCollection} 
                  subCollectionClick={subCollectionClick}/>
            </li>                  
        ))}
        </List>
      </div>
    </Drawer>
  )
}
